import { useState } from "react";
import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { ChevronDown } from "lucide-react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import {
  getIntegrationBuilderSingleAPIEndpointPathForId,
  navigateHelper,
} from "../../../../router/RouterUtils";
import useBlueprintContext from "../../context/useBlueprintContext";
import { APIEndpointUsage } from "../hooks/useAPIEndpointsUsed";

interface Props {
  usage: APIEndpointUsage;
  integrationID: string;
}

const APIEndpointUsedRow = ({ usage, integrationID }: Props) => {
  // state
  const [isStepListExpanded, setIsStepListExpanded] = useState<boolean>(false);

  // hooks
  const history = useHistory();
  const { scrollToStep } = useBlueprintContext();

  // derived state
  const { endpointID, method, path, stepIDs } = usage;
  const label = method && path ? `${method} ${path}` : endpointID;

  // event handlers
  const onViewEndpoint = () =>
    navigateHelper(
      history,
      getIntegrationBuilderSingleAPIEndpointPathForId(integrationID, endpointID),
      true
    );

  // render
  return (
    <div>
      <div className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-x-2">
        <Button
          variant={ButtonVariant.TextBlue}
          size="sm"
          onClick={onViewEndpoint}
          className="whitespace-normal break-words text-left"
        >
          {label}
        </Button>
        <Button
          variant={ButtonVariant.IconShadowHidden}
          className="bg-transparent"
          size="sm"
          ariaLabel={isStepListExpanded ? "Hide steps in Blueprint" : "Show steps in Blueprint"}
          onClick={() => setIsStepListExpanded(!isStepListExpanded)}
        >
          <ChevronDown
            size={12}
            className={clsx("transition-transform", isStepListExpanded && "rotate-180")}
          />
        </Button>
      </div>
      {isStepListExpanded && (
        <div className="flex flex-col items-start pl-4">
          {stepIDs.map((stepID) => (
            <Button
              key={stepID}
              variant={ButtonVariant.TextBlue}
              size="sm"
              onClick={() => scrollToStep(stepID)}
            >
              {stepID}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default APIEndpointUsedRow;
